"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "scrollIntoViewIfNeeded", {
    enumerable: true,
    get: function() {
        return scrollIntoViewIfNeeded;
    }
});
const _getScrollableParent = require("./getScrollableParent");
const scrollIntoViewIfNeeded = (el)=>{
    const scrollParent = (0, _getScrollableParent.getScrollableParent)(el);
    if (scrollParent == null) {
        return;
    }
    try {
        const { height: parentHeight } = scrollParent.getBoundingClientRect();
        const { height: itemHeight } = el.getBoundingClientRect();
        const distanceFromScrollTop = el.offsetTop - scrollParent.scrollTop;
        if (distanceFromScrollTop < 0) {
            scrollParent.scrollTop = el.offsetTop;
        } else if (distanceFromScrollTop + itemHeight > parentHeight) {
            scrollParent.scrollTop = el.offsetTop - (parentHeight - itemHeight);
        }
    } catch  {
    // Do nothing.
    }
};

//# sourceMappingURL=scrollIntoViewIfNeeded.js.map